import * as Api from '../api/consult'
const state = {
  printObj: {}
}
const mutations = {
  SET_PRINT_OBJ(state, value) {
    state.printObj = value
  }
}
const actions = {}
export default {
  state,
  mutations,
  actions
}
